import React from "react";
import { useNavigate } from "react-router-dom";

const companies = [
  { id: 1, name: "Alpha Security" },
  { id: 2, name: "Bravo Protection" },
  { id: 3, name: "Delta Guard Services" },
  // Add more companies here
];

const CompanyList = () => {
  const navigate = useNavigate();

  const handleClick = (id: number) => {
    navigate(`/company/${id}`);
  };

  return (
    <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {companies.map((company) => (
        <div
          key={company.id}
          className="p-4 border rounded-lg shadow-md hover:bg-gray-100 cursor-pointer"
          onClick={() => handleClick(company.id)}
        >
          <h2 className="text-xl font-bold">{company.name}</h2>
        </div>
      ))}
    </div>
  );
};

export default CompanyList;